import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import { CtExamTemplateAdd, CtExamTemplateReceiveTest } from 'containers';

import * as commonVar from 'libs/commonVar';

import classNames from 'classnames/bind';
import styles from './ExamTemplateMenu.css';
const cx = classNames.bind(styles);

// 템플릿 상단의 버튼 영역
class ExamTemplateMenu extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { isAuth } = this.props;

    return (
      <div className={cx('func-list')}>
        {/* 템플릿 등록 버튼 */}
        {commonVar.isGs !== 1 && commonVar.isSaas === 1 && isAuth === 2 && <CtExamTemplateAdd />}
        {/* 수신 테스트 버튼 */}
        <CtExamTemplateReceiveTest />
      </div>
    );
  }
}

ExamTemplateMenu.propTypes = {
  //
};
ExamTemplateMenu.defaultProps = {
  //
};

const mapStateToProps = (state, props) => {
  return {
    isAuth: state.user.get('isAuth')
  };
};

export default connect(mapStateToProps)(ExamTemplateMenu);



// WEBPACK FOOTER //
// ./src/script/components/examTemplate/ExamTemplateMenu.js